var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDifficultyBeginner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 29,
    viewBox: "0 0 47 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.132 10.2242L27.1322 10.2241C27.722 9.88684 28.4469 9.88869 29.0382 10.2306C29.626 10.5722 29.9892 11.2025 29.99 11.8836V26.551C29.99 27.6059 29.1348 28.461 28.08 28.461H18.922C17.8671 28.461 17.012 27.6059 17.012 26.551V17.115C17.012 16.4297 17.3796 15.7972 17.9742 15.4571L27.132 10.2242Z",
    stroke: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.899 19.1636C12.155 18.7286 11.239 18.7276 10.494 19.1556L1.21501 24.4586C0.266007 24.9996 -0.199993 26.1126 0.0810065 27.1686C0.361007 28.2256 1.31701 28.9606 2.41001 28.9606H11.69C13.021 28.9606 14.1 27.8816 14.1 26.5506V21.2466C14.101 20.3896 13.643 19.5936 12.899 19.1636Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M45.548 0.796114L45.5481 0.79622C46.137 1.13781 46.4998 1.76789 46.499 2.44814V2.44872V26.5507C46.499 27.6056 45.6439 28.4607 44.589 28.4607H35.31C34.2552 28.4607 33.4 27.6056 33.4 26.5507V7.75172C33.4 7.06626 33.7678 6.43291 34.363 6.09288L34.3631 6.09285L43.6421 0.790847L43.6427 0.790518C44.2328 0.452248 44.9584 0.453789 45.548 0.796114Z",
    stroke: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDifficultyBeginner);
export default __webpack_public_path__ + "static/media/difficultyBeginner.839c1167e1f29a780a8b31bb92283392.svg";
export { ForwardRef as ReactComponent };